import Alpine from 'alpinejs';
import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';
import gsap from 'gsap';
import { Draggable } from 'gsap/Draggable';
import { InertiaPlugin } from 'gsap/InertiaPlugin';
import { SplitText } from 'gsap/SplitText';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { horizontalLoop } from './horizontalLoop';
import Cookies from 'js-cookie';

// Swiper
import 'swiper/css';
window.Swiper = Swiper;
Swiper.use([Autoplay, Navigation]);

// GSAP
window.gsap = gsap;
window.horizontalLoop = horizontalLoop;
gsap.registerPlugin(SplitText, ScrollTrigger, Draggable, InertiaPlugin);
window.SplitText = SplitText;
window.ScrollTrigger = ScrollTrigger;
window.Draggable = Draggable;
window.InertiaPlugin = InertiaPlugin;

// Cookies
window.Cookies = Cookies;

// Alpine
window.Alpine = Alpine;

// Init Alpine after page load
document.addEventListener('DOMContentLoaded', () => {
	Alpine.start();
});
